import { useState, useEffect, useMemo } from "react";
import Joi from "joi-browser";
import Form from "V2.0/components/Form";
import { putModelSettings } from "../../service";
import { message } from "antd";

const template = [
  {
    name: "temperature",
    label: "Temperature",
    type: "slider",
    min: 0,
    max: 1,
    step: 0.1,
  },

  {
    name: "maxOutputTokens",
    label: "Maximum Output token",
    type: "slider",
    min: 100,
    max: 1000,
  },
];

const buttonInfo = { label: "Save", style: "right-side" };

const schema = {
  gptResponseModel: Joi.string().required().label("Model"),
  maxOutputTokens: Joi.label("Maximum output tokens"),
  temperature: Joi.label("Temperature"),
};

const modelsMappings = {
  "gemini-2.5-flash-lite-preview-06-17": "gemini-2.5-flash-lite",
};

function GPTResponseModelSettings(props) {
  const { modelSettings, workspaceId, assistantId, syncAssistant, onSuccess } =
    props;
  const { gptResponseModel, temperature, maxOutputTokens } = modelSettings;

  const [inputField, setInputField] = useState({
    gptResponseModel,
    temperature,
    maxOutputTokens,
  });

  useEffect(() => {
    if (modelSettings) {
      const { gptResponseModel, temperature, maxOutputTokens } = modelSettings;

      const updatedGptResponseModel = modelsMappings[gptResponseModel];

      setInputField({
        gptResponseModel: Boolean(updatedGptResponseModel)
          ? updatedGptResponseModel
          : gptResponseModel,
        temperature,
        maxOutputTokens,
      });
    }
  }, [modelSettings]);

  const [loading, setLoading] = useState(false);
  const [errorMessage] = useState({});

  const updatedTemplate = useMemo(() => {
    const { gptResponseModel } = modelSettings;

    const gpt4oMiniOption =
      gptResponseModel === "superdash-gpt4o-mini"
        ? { id: 1, value: "superdash-gpt4o-mini", label: "GPT 4o mini" }
        : { id: 1, value: "gpt-4o-mini", label: "GPT 4o mini" };

    const gpt4_1NanoOption =
      gptResponseModel === "superdash-4.1-nano"
        ? { id: 10, value: "superdash-4.1-nano", label: "GPT 4.1 Nano" }
        : { id: 10, value: "gpt-4.1-nano", label: "GPT 4.1 Nano" };

    const gpt4_1MiniOption =
      gptResponseModel === "superdash-4.1-mini"
        ? { id: 9, value: "superdash-4.1-mini", label: "GPT 4.1 Mini" }
        : { id: 9, value: "gpt-4.1-mini", label: "GPT 4.1 Mini" };

    return [
      {
        name: "gptResponseModel",
        label: "Model",
        type: "select",
        options: [
          gpt4_1NanoOption,
          gpt4_1MiniOption,
          gpt4oMiniOption,
          // { id: 2, value: "superdash-35-turbo", label: "GPT 3.5 Turbo" },
          { id: 2, value: "gemini-1.5-flash", label: "Gemini 1.5 Flash" },
          { id: 3, value: "gemini-2.0-flash", label: "Gemini 2.0 Flash" },
          {
            id: 4,
            value: "gemini-2.5-flash",
            label: "Gemini 2.5 Flash",
          },
          {
            id: 5,
            value: "gemini-2.5-flash-lite",
            label: "Gemini 2.5 Flash Lite (New)",
          },
          {
            id: 6,
            value: "claude-3-5-haiku-20241022",
            label: "Claude 3.5 Haiku",
          },
          { id: 7, value: "groq/llama3-8b-8192", label: "LLaMA3 8b" },
          { id: 8, value: "groq/llama3-70b-8192", label: "LLaMA3 70b" },
        ],
      },
      ...template,
    ];
  }, [modelSettings]);

  const handleCreate = async (data) => {
    setLoading(true);
    try {
      const response = await putModelSettings({
        workspaceId,
        assistantId,
        payload: data,
      });
      if (response.status === 200) {
        message.success("Model updated");
        syncAssistant((prevAssistant) => {
          return {
            ...prevAssistant,
            modelSettings: response.data,
          };
        });
        setLoading(false);
        onSuccess();
      }
    } catch (e) {
      message.error(
        e.response.data?.msg ||
          e.response.data?.message ||
          e.response.data?.error ||
          "Failed to udpate model"
      );
      console.error("Error updating model settings");
      setLoading(false);
    }
  };

  return (
    <div>
      <Form
        key={JSON.stringify(inputField)}
        errorMessage={errorMessage}
        inputField={inputField}
        template={updatedTemplate}
        schema={schema}
        onSubmit={handleCreate}
        loading={loading}
        setLoading={setLoading}
        buttonInfo={buttonInfo}
      />
    </div>
  );
}

export { GPTResponseModelSettings };
